import { fromJS } from 'immutable';
import { fromPairs, map } from 'lodash-es';

import initialState from '../../Store/initialState';

import { locale } from '../Tools/reducers';
import * as types from './actionTypes';
import * as systemTypes from '../System/actionTypes';
import { getPartyList, appendPartyList } from './transform';

let newState;
let newParty;

const parties = (state = initialState.get('parties'), action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        return state.set('strings', locale(action?.data?.language, 'party'));
      }

      // PARTIES
      case types.FETCH_PARTIES_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingParties'], true);
        return newState;
      }

      case types.FETCH_PARTIES_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            parties: fromPairs(map(action.data?.parties, i => [String(i.id), i])),
            list: getPartyList(action.data?.parties),
            currentOffset: action.offset
          })
        );

        newState = newState.setIn(['loading', 'isLoadingParties'], false);
        return newState;
      }

      case types.FETCH_PARTIES_FAIL: {
        newState = state.setIn(['loading', 'isLoadingParties'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH PARTY
      case types.FETCH_PARTY_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingParty'], true);
        return newState;
      }

      case types.FETCH_PARTY_SUCCESS: {
        // set/update party in store
        newParty = fromJS(action.data.parties[0]);
        newParty = state.getIn(['parties', String(action.id)])
          ? newParty.mergeDeep(state.getIn(['parties', String(action.id)]))
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isLoadingParty'], false);
        return newState;
      }

      case types.FETCH_PARTY_FAIL: {
        newState = state.setIn(['parties', String(action.id)], undefined);
        newState = newState.setIn(['loading', 'isLoadingParty'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // PUT PARTY_PERSON
      case types.UPDATE_PARTY_PERSON_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingPartyPerson'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        return newState;
      }
      case types.UPDATE_PARTY_PERSON_SUCCESS: {
        if (!action.data.ok) return state; // problably useless
        // set/update party in store
        newParty = fromJS(action.data.item);
        newParty = state.getIn(['parties', String(action.id)])
          ? state.getIn(['parties', String(action.id)]).mergeDeep(newParty)
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isUpdatingPartyPerson'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(
          ['alerts', 'successes'],
          fromJS([{ t: Date.now(), msg: 'party.alerts.successful_update.msg' }])
        );
        return newState;
      }
      case types.UPDATE_PARTY_PERSON_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingPartyPerson'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // PUT PARTY_COMPANY
      case types.UPDATE_PARTY_COMPANY_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingPartyCompany'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }
      case types.UPDATE_PARTY_COMPANY_SUCCESS: {
        if (!action.data.ok) return state; // problably useless
        // set/update party in store
        newParty = fromJS(action.data.item);
        newParty = state.getIn(['parties', String(action.id)])
          ? state.getIn(['parties', String(action.id)]).mergeDeep(newParty)
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isUpdatingPartyCompany'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS(['party.alerts.successful_update.msg']));
        return newState;
      }
      case types.UPDATE_PARTY_COMPANY_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingPartyCompany'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // PUT PARTY_ADDRESSES
      case types.UPDATE_PARTY_ADDRESSES_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingPartyAddresses'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }
      case types.UPDATE_PARTY_ADDRESSES_SUCCESS: {
        if (!action.data.ok) return state; // problably useless
        // set/update party in store
        newParty = fromJS({ addresses: action.data });
        newParty = state.getIn(['parties', String(action.id)])
          ? state.getIn(['parties', String(action.id)]).mergeDeep(newParty)
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isUpdatingPartyAddresses'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS(['party.alerts.successful_update.msg']));
        return newState;
      }
      case types.UPDATE_PARTY_ADDRESSES_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingPartyAddresses'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // PUT PARTY_CONTACTS
      case types.UPDATE_PARTY_CONTACTS_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingPartyContacts'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }
      case types.UPDATE_PARTY_CONTACTS_SUCCESS: {
        if (!action.data.ok) return state; // problably useless
        // set/update party in store
        newParty = fromJS({ contact_mechanisms: action.data });
        newParty = state.getIn(['parties', String(action.id)])
          ? state.getIn(['parties', String(action.id)]).mergeDeep(newParty)
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isUpdatingPartyContacts'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS(['party.alerts.successful_update.msg']));
        return newState;
      }
      case types.UPDATE_PARTY_CONTACTS_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingPartyContacts'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // PUT PARTY_BANK_ACCOUNTS
      case types.UPDATE_PARTY_BANK_ACCOUNTS_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingPartyBankAccounts'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }
      case types.UPDATE_PARTY_BANK_ACCOUNTS_SUCCESS: {
        if (!action.data.ok) return state; // problably useless
        // set/update party in store
        newParty = fromJS({ bank_accounts: action.data });
        newParty = state.getIn(['parties', String(action.id)])
          ? state.getIn(['parties', String(action.id)]).mergeDeep(newParty)
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isUpdatingPartyBankAccounts'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS(['party.alerts.successful_update.msg']));
        return newState;
      }
      case types.UPDATE_PARTY_BANK_ACCOUNTS_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingPartyBankAccounts'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // PUT PARTY_CONTACTS
      case types.UPDATE_PARTY_RELATIONS_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingPartyRelations'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }
      case types.UPDATE_PARTY_RELATIONS_SUCCESS: {
        if (!action.data.ok) return state; // problably useless
        // set/update party in store
        newParty = fromJS({ relations: action.data });
        newParty = state.getIn(['parties', String(action.id)])
          ? state.getIn(['parties', String(action.id)]).mergeDeep(newParty)
          : newParty;
        newState = state.setIn(['parties', String(action.id)], newParty);
        newState = newState.setIn(['loading', 'isUpdatingPartyRelations'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS(['party.alerts.successful_update.msg']));
        return newState;
      }
      case types.UPDATE_PARTY_RELATIONS_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingPartyRelations'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // POST CHANGE_PAYMENT_CARD
      case types.CHANGE_PAYMENT_CARD_REQUEST: {
        newState = state.setIn(['loading', 'isChangingPaymentCard'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }
      case types.CHANGE_PAYMENT_CARD_SUCCESS: {
        if (!action.data.ok) return state;
        newParty = fromJS({ paymentCard: action.data });
        newState = newState.setIn(['loading', 'isChangingPaymentCard'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS(['party.alerts.successful_update.msg']));
        return newState;
      }
      case types.CHANGE_PAYMENT_CARD_FAIL: {
        newState = state.setIn(['loading', 'isChangingPaymentCard'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      // LOAD MORE PARTIES
      case types.LOAD_MORE_PARTIES_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingParties'], true);
        return newState;
      }

      case types.LOAD_MORE_PARTIES_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            parties: fromPairs(map(action.data?.parties, i => [String(i.id), i])),
            list: appendPartyList(state.getIn(['list']), action.data?.parties),
            currentOffset: action?.offset
          })
        );

        newState = newState.setIn(['loading', 'isLoadingParties'], false);
        return newState;
      }

      case types.LOAD_MORE_PARTIES_FAIL: {
        newState = state.setIn(['loading', 'isLoadingParties'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default parties;
